export default __webpack_public_path__ + "static/media/Icon_SG.702465f5.png";